import Vue from "vue";
import io from "socket.io-client";
import TIMHomePage from "./pages/f7-tim-emp-client-chat/home.vue";
import TIMConversationPage from "./pages/f7-tim-emp-client-chat/conversation.vue";
import TIMUnauthorizedPage from "./pages/f7-tim-emp-client-chat/unauthorized.vue";
import TIMPageNotFound from "./pages/f7-tim-emp-client-chat/notfound.vue";

import HomePage from "./pages/f7-emp-client-chat/home.vue";
import ConversationPage from "./pages/f7-emp-client-chat/conversation.vue";
import UnauthorizedPage from "./pages/f7-emp-client-chat/unauthorized.vue";
import PageNotFound from "./pages/f7-emp-client-chat/notfound.vue";

import axios from "axios";
import jwt_decode from "jwt-decode";
import store from "./store/index";
import _ from "lodash";
import { JobRoles, API_URL } from "./core/const";
let jwt = {
  decode: (token) => {
    return jwt_decode(token);
  },
};

let $http = axios.create({
  baseURL: API_URL.LIVE,
  timeout: 30000,
});
export default [
  {
    path: "/chat",
    meta: {
      auth: true,
    },
    async: function (to, routeFrom, resolve) {
      (async () => {
        console.log("employee/chat");
        $(".loadingsvg").hide();
        var errorMsg =
          "User token has been expired, please login again to access chat page.";
        var token = localStorage.getItem("token");
        var isAuth = false;
        var uriToken = !_.isEmpty(to.query.token) ? to.query.token : "";
        var authorization =
          uriToken != token && !_.isEmpty(to.query.token)
            ? uriToken
            : token
            ? token
            : "";
        var user = {
          token: authorization,
          isEmployee: null,
          id: null,
        };
        try {
          await $http
            .get("/api/v2/authorise/isAuth", {
              headers: {
                "Content-Type": "application/json",
                Authorization: authorization,
              },
            })
            .then((res) => {
              console.log("authorise/isAuth", res);
              if (res.data.isAuth) {
                let payload = jwt.decode(authorization);
                let isEmployee = !!jwt.decode(authorization).employeeId;
                if (!isEmployee) {
                  localStorage.clear();
                  localStorage.setItem(
                    "errorMsg",
                    `User is not authorized, Don't have access role!`
                  );
                  console.warn(
                    "User is not authorized, Don't have access role!"
                  );
                  resolve({
                    component: TIMUnauthorizedPage,
                  });
                  return false;
                } else {
                  user.isEmployee = isEmployee;
                  user.id = isEmployee ? payload.employeeId : payload.clientId;
                  localStorage.setItem("user", JSON.stringify(user));
                  isAuth = true;
                  if (!localStorage.getItem("userInfoData") || !isEmployee) {
                    token = "";
                  }
                }
              } else {
                localStorage.clear();
              }
            })
            .catch((error) => {
              errorMsg = `Chat page not reponding, please try again.`;
            });

          if (
            isAuth &&
            ((!_.isEmpty(to.query.token) && to.query.token != token) ||
              authorization !== token)
          ) {
            console.log("check query token");
            try {
              localStorage.setItem("token", authorization);

              //   await $http.get(`/api/v2/index/startup`, {
              //     headers: {
              //       "Content-Type": "application/json"
              //     }
              //   }).then((res) => {
              //     localStorage.setItem('startupData', JSON.stringify(res.data));
              //   }).catch((error) => {
              //   });

              await $http
                .get(`/api/v2/index/cities`, {
                  headers: {
                    "Content-Type": "application/json",
                  },
                })
                .then((res) => {
                  localStorage.setItem("cities", JSON.stringify(res.data));
                })
                .catch(function (error) {});

              await $http
                .get(`/api/v2/${user.isEmployee ? "employee" : "client"}/me`, {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: authorization,
                  },
                })
                .then((res) => {
                  // if(_.get(res,'data.job_roles'))
                  // console.log('employee=', res)
                  if (user.isEmployee && !_.get(res, "data.is_active")) {
                    localStorage.clear();
                    localStorage.setItem(
                      "errorMsg",
                      `User is not authorized, Access denied!`
                    );
                    console.warn("User is not authorized, Access denied!");
                    resolve({
                      component: UnauthorizedPage,
                    });
                  } else {
                    localStorage.setItem("userInfoData", JSON.stringify(res));
                    localStorage.setItem(
                      "activeCityID",
                      _.get(res["data"]["client"], "city_id", "")
                    );
                  }
                })
                .catch((error) => {
                  localStorage.clear();
                });
            } catch (ex) {
              console.log(ex);
            }
          }
          if (authorization) {
            console.log("init vue socket");
            Vue.prototype.$socket = io("https://im.lovestruck.com", {
              path: "/socket.io",
              query: {
                token: authorization,
              },
            });
          }
        } catch (ex) {
          console.log(ex);
        }

        if (to.route.meta.auth) {
          var uri = window.location.toString();
          if (uri.indexOf("&token") > 0) {
            var clean_uri = uri.substring(0, uri.indexOf("&token"));
            window.history.pushState({}, document.title, clean_uri);
          }
          if (uri.indexOf("?token") > 0) {
            var clean_uri = uri.substring(0, uri.indexOf("?token"));
            window.history.pushState({}, document.title, clean_uri);
          }
          if (localStorage.getItem("token") == null) {
            localStorage.clear();
            localStorage.setItem("errorMsg", errorMsg);
            resolve({
              component: UnauthorizedPage,
            });
          } else {
            if (JSON.parse(localStorage.getItem("user")).isEmployee) {
              var job_roles = JSON.parse(localStorage.getItem("userInfoData"))
                .data.job_roles
                ? JSON.parse(localStorage.getItem("userInfoData"))
                    .data.job_roles.toString()
                    .split(",")
                    .map(function (item) {
                      return parseInt(item, 10);
                    })
                : [];
              let mergedRole = [...job_roles, ...JobRoles.roles];
              if (_.uniq(mergedRole).length !== mergedRole.length) {
                localStorage.removeItem("errorMsg");
                resolve({
                  component: HomePage,
                });
                $("div.loading").hide();
              } else {
                localStorage.clear();
                localStorage.setItem(
                  "errorMsg",
                  `User is not authorized, Don't have access role!`
                );
                console.warn("User is not authorized, Don't have access role!");
                resolve({
                  component: UnauthorizedPage,
                });
              }
            } else {
              await $http
                .post(
                  "api/v2/client/readConversation",
                  {},
                  {
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: authorization,
                    },
                  }
                )
                .then((res) => {
                  localStorage.removeItem("errorMsg");
                  resolve({
                    component: ConversationPage,
                  });
                  $("div.loading").hide();
                })
                .catch((error) => {});
            }
          }
        } else {
          localStorage.clear();
          resolve({
            component: UnauthorizedPage,
          });
        }
      })();
    },
    master: true,
    detailRoutes: [
      {
        path: "/conversation/:userID",
        component: ConversationPage,
        meta: {
          auth: true,
        },
      },
    ],
  },
  {
    path: "/conversation/:userID",
    component: ConversationPage,
    meta: {
      auth: true,
    },
  },
  {
    path: "/notfound",
    component: PageNotFound,
  },
  {
    path: "/tim-chat",
    meta: {
      auth: true,
    },
    async: function (to, routeFrom, resolve) {
      (async () => {
        console.log("employee/tim-chat");
        $(".loadingsvg").hide();
        var errorMsg =
          "User token has been expired, please login again to access chat page.";
        var token = localStorage.getItem("token");
        var isAuth = false;
        var uriToken = !_.isEmpty(to.query.token) ? to.query.token : "";
        var authorization =
          uriToken != token && !_.isEmpty(to.query.token)
            ? uriToken
            : token
            ? token
            : "";
        var user = {
          token: authorization,
          isEmployee: null,
          id: null,
        };
        try {
          await $http
            .get("/api/v2/authorise/isAuth", {
              headers: {
                "Content-Type": "application/json",
                Authorization: authorization,
              },
            })
            .then((res) => {
              if (res.data.isAuth) {
                let payload = jwt.decode(authorization);
                let isEmployee = !!jwt.decode(authorization).employeeId;

                if (!isEmployee) {
                  localStorage.clear();
                  localStorage.setItem(
                    "errorMsg",
                    `User is not authorized, Don't have access role!`
                  );
                  console.warn(
                    "User is not authorized, Don't have access role!"
                  );
                  resolve({
                    component: TIMUnauthorizedPage,
                  });
                  return false;
                } else {
                  user.isEmployee = isEmployee;
                  user.id = isEmployee ? payload.employeeId : payload.clientId;
                  localStorage.setItem("user", JSON.stringify(user));
                  isAuth = true;
                  if (!localStorage.getItem("userInfoData") || !isEmployee) {
                    token = "";
                  }
                }
              } else {
                localStorage.clear();
              }
            })
            .catch((error) => {
              errorMsg = `Chat page not reponding, please try again.`;
            });

          if (
            isAuth &&
            ((!_.isEmpty(to.query.token) && to.query.token != token) ||
              authorization !== token)
          ) {
            try {
              localStorage.setItem("token", authorization);
              //   await $http.get(`/api/v2/index/startup`, {
              //     headers: {
              //       "Content-Type": "application/json"
              //     }
              //   }).then((res) => {
              //     localStorage.setItem('startupData', JSON.stringify(res.data));
              //   }).catch((error) => {
              //   });

              await $http
                .get(`/api/v2/index/cities`, {
                  headers: {
                    "Content-Type": "application/json",
                  },
                })
                .then((res) => {
                  localStorage.setItem("cities", JSON.stringify(res.data));
                })
                .catch(function (error) {});

              await $http
                .get(`/api/v2/${user.isEmployee ? "employee" : "client"}/me`, {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: authorization,
                  },
                })
                .then((res) => {
                  // if(_.get(res,'data.job_roles'))
                  // console.log('employee=', res)
                  if (user.isEmployee && !_.get(res, "data.is_active")) {
                    localStorage.clear();
                    localStorage.setItem(
                      "errorMsg",
                      `User is not authorized, Access denied!`
                    );
                    console.warn("User is not authorized, Access denied!");
                    resolve({
                      component: TIMUnauthorizedPage,
                    });
                  } else {
                    localStorage.setItem("userInfoData", JSON.stringify(res));
                    localStorage.setItem(
                      "activeCityID",
                      _.get(res["data"]["client"], "city_id", "")
                    );
                  }
                })
                .catch((error) => {
                  localStorage.clear();
                });
            } catch (ex) {
              console.log(ex);
            }
          }
        } catch (ex) {
          console.log(ex);
        }

        if (to.route.meta.auth) {
          var uri = window.location.toString();
          if (uri.indexOf("&token") > 0) {
            var clean_uri = uri.substring(0, uri.indexOf("&token"));
            window.history.pushState({}, document.title, clean_uri);
          }
          if (uri.indexOf("?token") > 0) {
            var clean_uri = uri.substring(0, uri.indexOf("?token"));
            window.history.pushState({}, document.title, clean_uri);
          }
          if (localStorage.getItem("token") == null) {
            localStorage.clear();
            localStorage.setItem("errorMsg", errorMsg);
            resolve({
              component: TIMUnauthorizedPage,
            });
          } else {
            if (JSON.parse(localStorage.getItem("user")).isEmployee) {
              var job_roles = JSON.parse(localStorage.getItem("userInfoData"))
                .data.job_roles
                ? JSON.parse(localStorage.getItem("userInfoData"))
                    .data.job_roles.toString()
                    .split(",")
                    .map(function (item) {
                      return parseInt(item, 10);
                    })
                : [];
              let mergedRole = [...job_roles, ...JobRoles.roles];
              if (_.uniq(mergedRole).length !== mergedRole.length) {
                localStorage.removeItem("errorMsg");
                resolve({
                  component: TIMHomePage,
                });
                $("div.loading").hide();
              } else {
                localStorage.clear();
                localStorage.setItem(
                  "errorMsg",
                  `User is not authorized, Don't have access role!`
                );
                console.warn("User is not authorized, Don't have access role!");
                resolve({
                  component: TIMUnauthorizedPage,
                });
              }
            } else {
              await $http
                .post(
                  "api/v2/client/readConversation",
                  {},
                  {
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: authorization,
                    },
                  }
                )
                .then((res) => {
                  localStorage.removeItem("errorMsg");
                  resolve({
                    component: TIMConversationPage,
                  });
                  $("div.loading").hide();
                })
                .catch((error) => {});
            }
          }
        } else {
          localStorage.clear();
          resolve({
            component: TIMUnauthorizedPage,
          });
        }
      })();
    },
    master: true,
    detailRoutes: [
      {
        path: "/tim-conversation/:userID",
        component: TIMConversationPage,
        meta: {
          auth: true,
        },
      },
    ],
  },
  {
    path: "/tim-conversation/:userID",
    component: TIMConversationPage,
    meta: {
      auth: true,
    },
  },
  {
    path: "/tim-notfound",
    component: TIMPageNotFound,
  },
];
